<div class="modal-body p-md-5">
    <button type="button" class="btn-close" data-dismiss="modal" (click)="close()" style="outline: none;"></button>
    <h2 class="mg-b30 font-24 montserrat-medium">Tick all that apply</h2>
    <div class="new-options new-options__full-width">
        <div class="new-options--radio new-options--radio__checkbox border-0 mb-1"
            *ngFor="let category of categoryOptions">
            <input type="checkbox" [(ngModel)]="category.isSelected" (ngModelChange)="ifChecked()">
            <span class="shadow-0 new-options--color"></span>
            <span class="new-options--title"><strong>{{category.name}}</strong></span><br>
            <span class="new-options--subtitle">{{category.description}}</span>
        </div>
    </div>
    <div class="form-group mb-4 new-options" *ngIf="showCommentBox">
        <textarea class="new-options--input medium" placeholder="Any more details? (optional)"
            [(ngModel)]="comment"></textarea>
    </div>
    <div class="text-center" *ngIf="showCommentBox">
        <button class="btn btn-primary long-btn50" data-dismiss="modal" [disabled] = "!comment || comment.trim().length<10"
            (click)="submitFeedback($event)"><span>Submit</span></button>
    </div>
</div>
